export const ar = {
  footer: {
    description: "وصف قصير عن المنتج ورسالتـه.",
    resources: "الموارد",
    support: "الدعم",
    legal: "قانوني",
    validation: "التحقق من الأختام",
    history: "سجل الاستشارات",
    reports: "التقارير والإحصائيات",
    geolocation: "الموقع الجغرافي",
    complaint: "الإبلاغ عن المخالفات",
    helpCenter: "مركز المساعدة",
    tutorials: "الدروس",
    contact: "اتصال",
    faq: "الأسئلة الشائعة",
    reportProblem: "الإبلاغ عن مشكلة",
    terms: "شروط الاستخدام",
    privacy: "سياسة الخصوصية",
    cookies: "سياسة الكوكيز",
    licenses: "التراخيص",
    portal: "البوابة",
    copyright: "جميع الحقوق محفوظة.",
    social: {
      facebook: "فيسبوك",
      twitter: "تويتر",
      instagram: "إنستغرام",
      youtube: "يوتيوب",
    },
  },
  querysFilter: {
    title: "الفلاتر",
    description: "قم بتضييق نطاق البحث باستخدام الفلاتر أدناه.",
    inputPlaceholder: "البحث حسب المعرف",
    dateFilter: {
      all: "جميع التواريخ",
      today: "اليوم",
      lastSevenDays: "آخر 7 أيام",
      lastThirtyDays: "آخر 30 يوما",
    },
  },

  nav: {
    validateSeal: "تحقق من الختم",
    howItWorks: "كيف يعمل",
    faq: "الأسئلة الشائعة",
    reportProblem: "الإبلاغ عن مشكلة",
    contact: "تماس بگیرید",
    menu: "القائمة",
    benefits: "الفوائد",
    resources: "الموارد",
    queryHistory: "سجل الاستشارات",
  },
  contactPage: {
    title: "اتصل بنا",
    subtitle: "أرسل رسالتك إلى فريقنا",
    emailInputLabel: "البريد الإلكتروني",
    phoneInputLabel: "الهاتف (اختياري)",
    messageInputLabel: "الرسالة",
    messageInputPlaceholder: "اكتب رسالتك هنا...",
    submitButtonText: "إرسال الرسالة",
    whatsAppButton: "تواصل معنا عبر واتساب",
  },
  faqPage: {
    title: "الأسئلة الشائعة",
    subtitle: "اعثر على إجابات للأسئلة الأكثر شيوعا",
    items: [
      {
        question: "ما هي الأختام وكيف تعمل؟",
        answer:
          "الأختام هي ملصقات توثيق يتم وضعها على كل منتج. يحتوي كل ختم على رقم فريد ومتسلسل (مثل 1، 2، 3... حتى 1000)، مما يسمح بتتبع كل منتج بشكل فردي. هذا يضمن الأصالة والتحكم الكامل في عملية الإنتاج.",
      },
      {
        question: "هل يمكن تتبع الأختام بشكل فردي؟",
        answer:
          "نعم! يحتوي كل ختم على رقم فريد يسمح بتتبعه بشكل فردي. يمكنك عرض سجل أي ختم، بما في ذلك تاريخ إنشائه واستخدامه والمنتج الذي تم تطبيقه عليه.",
      },
    ],
  },
  denouncePage: {
    title: "الإبلاغ عن ختم مزيف",
    subtitle: "ساعدنا في مكافحة التزوير من خلال الإبلاغ عن الأختام المشبوهة",
    imagesRequired: "يرجى إضافة على الأقل مرة واحدة من الصور.",
    submittingText: "جار الإرسال...",

    imagesSectionTitle: "الصور",

    imagesUploadLabel: "انقر أو اسحب الصور هنا",
    imagesUploadHint: "PNG, JPG, WEBP حتى 10MB كل صورة",

    reporterSectionTitle: "بيانات المبلغ",
    sealSectionTitle: "معلومات الختم",
    detailsSectionTitle: "تفاصيل البلاغ",

    nameLabel: "الاسم الكامل",
    namePlaceholder: "اسمك",

    emailLabel: "البريد الإلكتروني",
    emailPlaceholder: "your@email.com",

    phoneLabel: "الهاتف (اختياري)",
    phonePlaceholder: "(00) 00000-0000",

    sealCodeLabel: "رمز الختم",
    sealCodePlaceholder: "مثال: SEAL-2024-XXXX",

    sealTypeLabel: "نوع الختم",
    sealTypePlaceholder: "اختر النوع",
    sealTypeOptions: {
      holographic: "هولوغرافي",
      other: "آخر",
    },

    brandLabel: "العلامة التجارية / الشركة المصنعة",
    brandPlaceholder: "اسم العلامة التجارية",

    productLabel: "اسم المنتج",
    productPlaceholder: "اسم المنتج",

    locationLabel: "مكان الشراء / العثور",
    locationPlaceholder: "المتجر أو المدينة أو رابط الموقع",

    reasonLabel: "سبب البلاغ",
    reasonPlaceholder: "اختر السبب",
    reasonOptions: {
      fakeSeal: "ختم مزيف بشكل واضح",
      invalidCode: "رمز غير صالح أثناء التحقق",
      duplicate: "رمز مكرر أو مستخدم مسبقا",
      damaged: "ختم متلاعب به أو تالف",
      suspicious: "منتج يشتبه في كونه مزيفا",
      other: "سبب آخر",
    },

    descriptionLabel: "وصف تفصيلي",
    descriptionPlaceholder:
      "يرجى وصف المخالفات التي لاحظتها على الختم أو المنتج بالتفصيل...",

    submitButtonText: "إرسال البلاغ",
  },

  common: {
    loadingConsultation: "جاري تنفيذ الاستعلام عن هذا النص الآن",
    cancel: "إلغاء",
    confirm: "تأكيد",
    back: "رجوع",
    retry: "إعادة المحاولة",
    loading: "جار التحميل...",
    error: "خطأ",
    success: "نجاح",
    yes: "نعم",
    no: "لا",
    close: "إغلاق",
    save: "حفظ",
    delete: "حذف",
    edit: "تعديل",
    view: "عرض",
    send: "إرسال",
    next: "التالي",
    previous: "السابق",
    validations: "عمليات التحقق",
    validating: "جار التحقق...",
    photo: "صورة",
    qrCode: "رمز QR",
    list: "قائمة",
    map: "خريطة",
    seal: "الختم",
    code: "الرمز",
    loadImages: "تحميل الصورة",
  },
  camera: {
    instructions: {
      title: "جهّز الختم",
      description:
        "وجّه الكاميرا نحو الختم وانتظر. سيتعرّف النظام على الختم ويلتقط الصورة تلقائيًا.",
      focusDesc: "ثبّت هاتفك بينما يلتقط النظام الصورة.",
      button: "ابدأ",
    },
    scanning: "جار المسح...",
    positionQRHere: "ضع رمز QR هنا",
    scanningAutomatically: "يتم المسح تلقائيا",
    takePhoto: "التقاط صورة",
    selectFile: "اختر صورة",
    retake: "إعادة الالتقاط",
    switchCamera: "تبديل الكاميرا",
    positionSealHere: "ضع الختم هنا",
    tapScreen: "اضغط على الشاشة للتركيز",
    tapToTakePhoto: "اضغط على الشاشة لالتقاط الصورة",
    guidanceDetected: "ثبّت هاتفك وانتظر.",
    guidancePreparing: "جار تجهيز الكاميرا...",
    guidanceFind: "وجّه الكاميرا نحو الختم.",
    guidanceCloser: "قرّب الكاميرا من الختم.",
    guidanceFarther: "أبعد الكاميرا قليلا.",
    guidanceCenter: "وسّط الختم.",
    guidanceHold: "ممتاز. ثبّت الكاميرا.",
    guidanceCapturing: "جار التقاط أفضل صورة...",
    waitingWhileCameraLoads: "يرجى الانتظار أثناء تحميل الكاميرا...",
    error: "خطأ في الكاميرا",
    permissionDenied: "تم رفض إذن الوصول إلى الكاميرا. يرجى السماح بالوصول.",
    cameraNotFound:
      "لم يتم العثور على كاميرا. تحقق من أن جهازك يحتوي على كاميرا متاحة.",
    accessError: "حدث خطأ أثناء الوصول إلى الكاميرا. حاول مرة أخرى.",
    loadingTimeout: "استغرق تحميل الكاميرا وقتا طويلا. تحقق من الأذونات.",
    capturedPhoto: "الرقم التسلسلي الملتقط",
    orientation: {
      portraitRecommended: "الوضع العمودي موصى به",
      landscapeRecommended: "الوضع الأفقي موصى به",
      rotateToPortrait: "قم بتدوير جهازك للوضع العمودي للحصول على أفضل تجربة.",
      rotateToLandscape: "قم بتدوير جهازك للوضع الأفقي للحصول على أفضل تجربة.",
      continueAnyway: "المتابعة على أي حال",
    },
    errorValidatingSeal: "خطأ أثناء التحقق من الختم",
    errorSendingPhoto: "خطأ أثناء إرسال الصورة",
    errorValidatingSealDescription:
      "حدث خطأ أثناء التحقق من الختم. يرجى المحاولة مرة أخرى.",
    errorProcessingImage: "حدث خطأ أثناء معالجة صورتك. حاول مرة أخرى.",
    aiValidationTitle: "الذكاء الاصطناعي يحلل ختمك",
    aiValidationDescription:
      "نتحقق من الصورة وعناصر الأمان. ستظهر النتيجة تلقائيًا.",
    aiValidationPhoto: "الصورة الملتقطة",
    aiValidationStatus: "التحليل جارٍ",
    aiValidationWait: "قد يستغرق ذلك بضع لحظات.",
    qrCodeNotFound: "لم يتم العثور على رمز QR",
    qrCodeNotFoundWithEntry:
      "تعذر تحديد رمز QR الخاص بالختم. تأكد من أن الختم واضح ومضاء ومركز في الصورة.",
    qrCodeNotFoundGeneric:
      "تعذر تحديد رمز QR صالح في الصورة. تأكد من أن الرمز واضح ومضاء ومركز في الصورة.",
  },
  tutorial: {
    qrTutorial: {
      title: "التحقق من أصالة الختم",
      description:
        "للمتابعة، التقط صورة للختم. سيقوم الذكاء الاصطناعي بالتحقق من عناصر الأمان.",
      button: "اضغط هنا لالتقاط الصورة",
    },
    photoStep: {
      step1: "استخدم نفس الختم من رمز QR الممسوح;",
      step2: "قم بتصوير ختم واحد فقط;",
      step3: "قم بتوسيط الختم على الشاشة;",
      step4: "لا تحرك الهاتف أثناء التقاط الصورة;",
      step5: "يرجى الانتظار بينما يقوم الذكاء الاصطناعي بإجراء التحقق؛;",
    },
    navigation: {
      previous: "السابق",
      next: "التالي",
      readQr: "قراءة رمز QR",
    },
    modal: {
      title: "حضر الكاميرا الخاصة بك",
      description: "الآن أنت جاهز لمسح رمز QR للختم!",
      button: "لنبدأ المسح!",
      autoRedirect: "إعادة التوجيه تلقائيا خلال 5 ثوان...",
    },
  },
  securityAlert: {
    title: "تنبيه أمني",
    potentiallyFake: "الختم قد يكون مزيفا!",
    description: "الرمز الفريد لا يتطابق مع المتوقع، مما قد يشير إلى تزوير.",
    question: "هل ترغب بالمتابعة وتسجيل هذا التحقق كغير صالح؟",
    confirmIrregularity: "تأكيد المخالفة",
  },
  errorDisplay: {
    geolocationRequired: "الموقع الجغرافي مطلوب",
    sealNotFound: "الختم غير موجود",
    verificationError: "خطأ في التحقق",
    geolocationInstructions: {
      title: "كيفية تفعيل الموقع الجغرافي:",
      step1: "• انقر على أيقونة الموقع في شريط العنوان",
      step2: '• اختر "السماح" لهذا الموقع',
      step3: "• أعد تحميل الصفحة بعد السماح",
    },
    tryAgain: "إعادة المحاولة",
    backToHome: "العودة للصفحة الرئيسية",
    noResults: "لا توجد نتائج",
    noValidations: "لا توجد عمليات تحقق",
  },
  addressInfo: {
    title: "العنوان",
    street: "الشارع",
    number: "الرقم",
    neighborhood: "الحي",
    city: "المدينة",
    state: "المقاطعة",
    zipCode: "الرمز البريدي",
  },
  clientInfo: {
    title: "معلومات العميل",
    cnpj: "CNPJ",
    name: "الاسم",
    phone: "الهاتف",
    email: "البريد الإلكتروني",
  },
  hashVerification: {
    title: "التحقق من الرمز الفريد",
    description: "قارن الرمز الفريد أدناه بما هو مطبوع على الختم",
    howToVerify:
      "كيفية التحقق: قارن الحروف واحدا تلو الآخر مع الرمز على الختم.",
    doesNotMatch: "غير متطابق",
    matches: "نعم، متطابق",
    processing: "جار المعالجة...",
    validating: "جار التحقق...",
  },
  loading: {
    validatingSeal: "جار التحقق من الختم...",
  },
  geoProtectRoute: {
    title: "جار الحصول على موقعك",
    description: "نحتاج إلى موقعك للتحقق من الأختام. قد يستغرق ذلك بضع ثوان.",
    loading: "جار تحميل الموقع...",
  },
  errorsDisplay: {
    geolocationRequired: "مطلوب تحديد الموقع",
    sealNotFound: "الختم غير موجود",
    verificationError: "خطأ في التحقق",
    howToEnableGeolocation: "كيفية تفعيل تحديد الموقع:",
    step1: "انقر على أيقونة الموقع في شريط العنوان",
    step2: 'اختر "السماح" لهذا الموقع',
    step3: "أعد تحميل الصفحة بعد السماح",
    retry: "حاول مرة أخرى",
    backHome: "العودة إلى الصفحة الرئيسية",
  },
  errorBoundary: {
    title: "حدث خطأ غير متوقع",
    description: "حدث خطأ أثناء تحميل هذه الصفحة.",
    reload: "إعادة تحميل الصفحة",
  },
  qrCodePage: {
    sealModal: {
      alignSeal: "قم بمحاذاة الختم داخل المنطقة المحددة",
      title: "لم يتم التعرف على الختم",
      lightingTitle: "الإضاءة",
      lightingDesc: "تجنب الظلال والانعكاسات على الختم.",
      framingTitle: "الإطار",
      framingDesc: "قم بتوسيط الختم داخل الإطار.",
      focusTitle: "التركيز",
      focusDesc: "قم بضبط تركيز الكاميرا قبل التقاط الصورة.",
      usedSealTitle: "المطابقة",
      usedSealDesc: "استخدم نفس الختم الخاص برمز QR",
      button: "التقاط صورة جديدة",
    },
    centerSealAlert: "قم بتوسيط الختم داخل المنطقة المحددة",
    hashDoesNotMatch:
      "رقم الختم لا يتطابق مع قاعدة بياناتنا. يرجى التحقق من أنك تستخدم نفس الختم الخاص برمز QR الذي تم مسحه.",
    seeAllSecurityItems: "عرض جميع عناصر الأمان",
    experienceAR: "جرّب الواقع المعزز",
    info: "الرقم المحدد في الصورة يتطابق مع سجل قاعدة البيانات.",
    clickSealToCheck: "انقر على الختم للتحقق من عناصر الأمان",
    uniqueCodeValidated: "تم التحقق من الرمز الفريد بنجاح",
    uniqueCodeDoesNotMatch: "الرمز الفريد غير متطابق",
    product: "منتج",
    productInfo: "معلومات المنتج",
    hash: "هاش",
    capColor: "لون الغطاء",
    serial: "الرقم التسلسلي:",
    serialNotFound: "الرقم التسلسلي غير موجود",
    importer: "المستورد:",
    batch: "الدفعة:",
    uniqueCode: "الرمز الفريد:",
    validated: "✓ تم التحقق",
    takePhoto: "التقاط صورة",
    securityItems: {
      config: {
        useArrows: "استخدم الأسهم أو اسحب للتنقل",
        goToItem: "الذهاب إلى العنصر",
        noSecurityItems: "لا توجد عناصر أمان متاحة في الوقت الحالي.",
      },
    },
    verificationResult: "نتيجة التحقق",
    suspicious:
      "تحقق من وجود علامات مرئية على العبث أو التناقضات، ثم تواصل مع المورد أو الشركة المصنعة المسؤولة عن المنتج الذي تم شراؤه.",
    qrCodeVerification: "التحقق من رمز QR",
    validQrCodeDescription:
      "يبدو رمز QR هذا صالحا، ومع ذلك، قم بتحليل عناصر الأمان باستخدام الذكاء الاصطناعي للتحقق من صحة الختم!",
    authenticityAnalysis: "تحليل أصالة ختم INMETRO",
    imageAnalyzed: "الصورة المحللة",
    qrCodeValid: "رمز QR صالح",
    elements: "عناصر",
    detectedElements: "العناصر المكتشفة",
    securityItemsTitle: "عناصر الأمان",
    explanation: "شرح",
    dataComparison: "مقارنة البيانات",
    dbSerial: "الرقم التسلسلي لقاعدة البيانات",
    photoSerial: "الرقم التسلسلي للصورة",
    confidence: "الثقة",
    backButton: "رجوع",
  },
  reportModal: {
    title: "الإبلاغ عن مخالفة",
    description: "أدخل مكان العثور على الختم المشبوه وأرفق صورة",
    locationLabel: "مكان المخالفة",
    locationPlaceholder: "مثال: صيدلية ABC، شارع الزهور 123",
    locationHint: "كن محددا: اسم المتجر، العنوان أو معلم قريب",
    photoLabel: "صورة الختم المشبوه",
    photoHint: "الصورة ستساعد فريقنا على تحديد المخالفة بشكل أفضل",
    takePhoto: "التقاط صورة",
    gallery: "المعرض",
    newPhoto: "جديدة",
    positionSealHere: "ضع الختم هنا",
    ensureReadable: "تأكد من أنه مقروء",
    sealReportedAsFake: "تم الإبلاغ عن الختم كـ مزيف:",
    sealIdentifiedAsFake:
      "تم تحديد هذا الختم على أنه مزيف محتمل بسبب عدم تطابق الرمز الفريد.",
    reportSent: "تم إرسال البلاغ!",
    investigationMessage: "سيتولى فريقنا التحقيق في المخالفة.",
    protocol: "الرقم المرجعي:",
    errorSending: "خطأ في إرسال البلاغ",
    tipsForBetterPhoto: "نصائح لالتقاط صورة أفضل:",
    tips: {
      lighting: "• تأكد من أن الختم مضاء جيدا",
      reflections: "• تجنب الانعكاسات والظلال",
      stability: "• أبق الكاميرا ثابتة",
      sealSize: "• يجب أن يشغل الختم معظم مساحة الصورة",
      readability: "• تأكد من أن جميع الرموز مقروءة",
    },
    sending: "جار الإرسال...",
    report: "إبلاغ",
  },
  additionalInfo: {
    title: "معلومات إضافية",
    description:
      "للحصول على مزيد من التفاصيل حول التحقق أو للإبلاغ عن مشكلات، يرجى الاتصال بالدعم الفني عبر موقع Mistral.",
  },
  validations: {
    title: "خريطة عمليات التحقق",
    subtitle: "اعرض جميع عمليات التحقق من الأختام في النظام.",
    filters: {
      title: "الفلاتر",
      description: "ابحث حسب العنوان أو الرقم التسلسلي أو السجل",
      placeholder: "ابحث عن عمليات التحقق...",
      status: {
        valid: "تم التحقق",
        invalid: "مرفوض",
        pending: "قيد المراجعة",
      },
      type: {
        title: "نوع التحقق",
        qrcode: "رمز QR",
        photo: "صورة",
      },
    },
    list: {
      title: "عمليات التحقق",
      loading: "جار تحميل عمليات التحقق...",
      empty: "لم يتم العثور على عمليات تحقق",
      found: "تم العثور على عمليات تحقق",
      view: {
        list: "قائمة",
        map: "خريطة",
      },
    },
    details: {
      title: "التفاصيل",
      date: "التاريخ",
      time: "الوقت",
      serialNumber: "الرقم التسلسلي",
      registerNumber: "رقم السجل",
      address: "العنوان الكامل",
      addressUnavailable: "العنوان غير متاح",
      photo: {
        title: "صورة الختم",
        none: "لا توجد صورة متاحة",
        capturedAt: "تم الالتقاط في: {{date}} الساعة {{time}}",
      },
      viewDetails: "عرض التفاصيل",
      close: "إغلاق التفاصيل",
    },
    map: {
      error: {
        title: "خطأ في تحميل الخريطة",
        description: "تحقق من اتصال الإنترنت أو حاول لاحقا.",
      },
      loadingMore: "جار تحميل المزيد من عمليات التحقق...",
    },
  },
  internalDashboard: {
    header: {
      title: "لوحة التحكم الإدارية",
      subtitle: "النظام الداخلي Inmetro",
      systemOnline: "النظام متصل",
      signOut: "تسجيل الخروج",
    },
    welcome: {
      title: "مرحبا بك في النظام الداخلي",
      subtitle: "اختر إحدى الخيارات أدناه للمتابعة",
    },
    cards: {
      mapAndQueries: {
        title: "الخريطة والاستعلامات",
        description: "الوصول إلى الخريطة التفاعلية وإجراء عمليات تحقق",
        button: "الوصول إلى الخريطة",
      },
      history: {
        title: "السجل",
        description: "عرض السجل الكامل للاستعلامات وعمليات التحقق",
        button: "عرض السجل",
      },
      userManagement: {
        title: "المستخدمون الداخليون",
        description: "إدارة المستخدمين الداخليين - إنشاء، تعديل، إزالة الوصول",
        button: "إدارة المستخدمين",
      },
    },
  },
  loginPage: {
    title: "تسجيل الدخول إلى حسابك",
    fields: {
      email: {
        label: "البريد الإلكتروني",
        placeholder: "أدخل بريدك الإلكتروني",
      },
      password: {
        label: "كلمة المرور",
        placeholder: "أدخل كلمة المرور",
      },
    },
    links: {
      forgotPassword: "نسيت كلمة المرور",
    },
    rememberMe: "تذكرني",
    buttons: {
      signIn: "تسجيل الدخول",
      signingIn: "جار تسجيل الدخول...",
    },
    screenReader: {
      hidePassword: "إخفاء كلمة المرور",
      showPassword: "إظهار كلمة المرور",
    },
    errors: {
      emailRequired: "البريد الإلكتروني مطلوب",
      emailInvalid: "البريد الإلكتروني غير صالح",
      cpfInvalid: "يجب أن يحتوي CPF على 11 رقما",
      passwordRequired: "كلمة المرور مطلوبة",
      passwordMinLength: "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
      invalidCredentials: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
      serverError: "خطأ داخلي في الخادم",
    },
    toasts: {
      loginError: "خطأ في تسجيل الدخول. تحقق من بيانات الاعتماد.",
      loginSuccess: "تم تسجيل الدخول بنجاح!",
      serverError: "خطأ داخلي في الخادم. حاول مرة أخرى.",
    },
  },
  queryPage: {
    title: "مقارنة الإدخالات",
    sections: {
      imageComparison: "مقارنة الصور",
      comparisonSummary: "ملخص المقارنة",
      detailedAnalysis: "تحليل مفصل",
    },
    sealOwner: {
      title: "بيانات الشركة",
      description: "معلومات عن الشركة المسؤولة عن الختم.",
      cnpj: "CNPJ",
      companyName: "اسم الشركة",
      productName: "اسم المنتج",
      notProvided: "غير متوفر",
    },
    sources: {
      database: "الرقم التسلسلي المتوقع",
      photo: "صورة",
    },
    fields: {
      serialNumber: "الرقم التسلسلي",
      publicHash: "الهاش العام",
    },
    status: {
      match: "متطابق",
      mismatch: "غير متطابق",
      partial: "جزئي",
      missing: "غير موجود",
      discrepancyDetected: "تم اكتشاف اختلاف",
      detected: "تم الكشف",
    },
    messages: {
      noImage: "لا توجد صورة",
      notFound: "غير موجود",
      valueDiffers: "تختلف هذه القيمة عن المسجلة في قاعدة البيانات.",
    },
    buttons: {
      back: "رجوع",
      validateAnother: "تحقق من ختم آخر",
    },
    emptyState: {
      title: "لا توجد سجلات",
      description: "لا توجد إدخالات لهذه الاستعلام.",
      button: "رجوع",
    },
    notFound: {
      title: "الاستعلام غير موجود",
      description: "تعذر العثور على بيانات لهذا الاستعلام.",
      button: "رجوع",
    },
    aiAnalysis: {
      title: "التحليل الذكي",
      badge: "تم إنشاؤه بواسطة الذكاء الاصطناعي",
      noAnalysis: "تعذر إنشاء تحليل لهذه الإدخالات.",
      loading: {
        title: "جار تحليل الإدخالات...",
        description: "يقوم الذكاء الاصطناعي بمقارنة البيانات وتوليد رؤى",
      },
      error: {
        title: "خطأ في التحليل",
        description: "تعذر إنشاء التحليل. حاول مرة أخرى لاحقا.",
        button: "إعادة المحاولة",
      },
      disclaimer:
        "يتم إنشاء هذا التحليل تلقائيا وقد لا يعكس جميع التفاصيل الدقيقة.",
    },
    dataComparisonCard: {
      title: "التحقق من الرقم التسلسلي",
      database: "قاعدة البيانات",
      found: "تم العثور عليه",
      photo: "الصورة (OCR)",
      detected: "تم الاكتشاف",
      notDetected: "غير مكتشف",
      notFound: "غير موجود",
      mismatchTitle: "اختلاف في الرقم التسلسلي",
      highConfidenceMessage:
        "يشير التحليل إلى درجة ثقة عالية بأن الختم أصلي (نسبة الثقة: {confidence}٪)، ومع ذلك فإن الرقم المكتشف في الصورة لا يتطابق مع الرقم المسجل في قاعدة البيانات. قد يشير ذلك إلى ختم أصلي تم وضعه بشكل غير صحيح، أو احتمال حدوث تلاعب، أو أن الصورة مأخوذة من ختم آخر.",
      lowConfidenceMessage:
        "الرقم المكتشف في الصورة لا يتطابق مع الرقم المسجل في قاعدة البيانات. بالإضافة إلى ذلك، فإن مستوى الثقة في الاكتشاف منخفض ({confidence}٪)، مما قد يشير إلى صعوبة في القراءة أو مشاكل في الختم.",
      partialMessage:
        "تم العثور على الرقم التسلسلي في قاعدة البيانات، ولكن لم يكن من الممكن قراءة الرقم من الصورة. قد يحدث هذا إذا كانت جودة الصورة منخفضة أو إذا كان الختم تالفا.",
    },
    explanationSection: {
      title: "كيف تفسر النتائج؟",
      levels: {
        high: {
          range: "80% - 100%",
          trust: "ثقة عالية",
          description: "تم تحديد العنصر بثقة.",
        },
        medium: {
          range: "60% - 79%",
          trust: "ثقة متوسطة",
          description: "توجد مؤشرات على العنصر، لكن نوصي بالتحقق الإضافي.",
        },
        low: {
          range: "0% - 59%",
          trust: "ثقة منخفضة",
          description: "لم يتم تأكيد العنصر في هذه اللقطة.",
        },
      },
      footer:
        "يقوم الذكاء الاصطناعي لدينا بتحليل الصورة للبحث عن عناصر الأمان الخاصة بختم INMETRO. تشير النسبة المئوية إلى مستوى اليقين في تحديد كل عنصر بشكل صحيح.",
    },
    verdictCard: {
      authentic: {
        title: "ختم أصلي",
        subtitle: "تم التحقق من عناصر الأمان الخاصة بالختم بنجاح!",
      },
      warning: {
        title: "تحقق غير حاسم",
        subtitle: "بعض العناصر تحتاج إلى مراجعة",
      },
      suspicious: {
        title: "ختم مشبوه",
        subtitle: "لم يكن من الممكن تأكيد الأصالة",
      },
      aiBadge: "تحليل بالذكاء الاصطناعي",
      overallConfidence: "مستوى الثقة العام",
    },
  },
  notFoundPage: {
    title: "404",
    message: "عذرا! الصفحة التي تبحث عنها غير موجودة.",
    backText: "يمكنك العودة إلى",
    homeLink: "الصفحة الرئيسية",
  },
  reportPage: {
    header: {
      badge: "نظام التحقق من الأختام",
      title: "الإبلاغ عن المخالفات",
      subtitle:
        "أبلغ عن الأختام المزورة أو غير النظامية للمساهمة في الأمان والامتثال.",
      anonymousTitle: "إبلاغ مجهول",
      anonymousSubtitle: "ستظل هويتك محمية",
      backButton: "العودة إلى الصفحة الرئيسية",
    },
    howToReport: {
      title: "كيفية الإبلاغ",
      subtitle: "اتبع هذه الخطوات لتقديم بلاغك",
      steps: {
        step1: {
          title: "املأ النموذج",
          description: "قدم كل التفاصيل الممكنة حول المخالفة",
        },
        step2: {
          title: "أرفق الأدلة",
          description: "أرسل صورا واضحة للختم المشبوه للتحليل",
        },
        step3: {
          title: "أدخل بياناتك",
          description: "بياناتك اختيارية لكنها تساعد في التحقيق",
        },
        step4: {
          title: "تابع العملية",
          description: "ستتلقى تحديثات حول حالة بلاغك",
        },
      },
    },
    identifyingFakes: {
      title: "كيفية التعرف على الأختام المزيفة",
      subtitle: "خصائص يجب التحقق منها",
      characteristics: {
        holographic: {
          title: "عناصر هولوجرافية",
          description:
            "تحقق مما إذا كان الختم يحتوي على علامات مائية وعناصر هولوجرافية تتغير مع الزاوية",
        },
        qrCode: {
          title: "رمز QR فعال",
          description:
            "تحقق مما إذا كان رمز QR يعمل ويوجه إلى الموقع الرسمي لـ {{productName}}",
        },
        printQuality: {
          title: "جودة الطباعة",
          description:
            "تحقق من وجود أخطاء في الطباعة أو جودة ضعيفة أو ألوان غير صحيحة",
        },
        serialNumber: {
          title: "رقم تسلسلي صالح",
          description: "تحقق مما إذا كان الرقم التسلسلي صالحا في النظام الرسمي",
        },
      },
      guideLink: "عرض الدليل الكامل للتعرف",
    },
    form: {
      title: "نموذج الإبلاغ",
      subtitle: "املأ الحقول أدناه بمعلومات حول المخالفة.",
      steps: {
        information: "المعلومات",
        contact: "الاتصال",
        confirmation: "التأكيد",
        stepLabel: "الخطوة {{current}} من {{total}}",
      },
      fields: {
        irregularityType: {
          label: "نوع المخالفة",
          placeholder: "اختر نوع المخالفة",
          options: {
            fake: "ختم مزيف",
            tampered: "ختم معدل",
            reused: "ختم معاد استخدامه",
            noSeal: "منتج بدون ختم",
            other: "أخرى",
          },
        },
        description: {
          label: "وصف المخالفة",
          placeholder: "صف المخالفة بالتفصيل",
          hint: "اشمل تفاصيل مثل خصائص الختم والمشكلات المحددة.",
        },
        location: {
          label: "المكان",
          placeholder: "أين وجد الختم",
        },
        date: {
          label: "تاريخ الحادث",
        },
        image: {
          label: "صورة الختم",
          uploadText: "انقر للرفع",
          tips: {
            title: "نصائح لصورة جيدة:",
            lighting: "إضاءة جيدة بدون انعكاسات",
            centered: "الختم كامل ومركز",
            sharp: "صورة واضحة وغير ضبابية",
            format: "الصيغ: JPG، PNG (حد أقصى 5MB)",
          },
        },
        company: {
          label: "الشركة / المتجر (اختياري)",
          placeholder: "اسم الشركة أو المتجر",
          hint: "أدخل اسم المكان الذي وجد فيه الختم.",
        },
        contact: {
          label: "البريد الإلكتروني للتواصل",
          placeholder: "your@email.com",
          hint: "سيستخدم بريدك فقط للتحديثات حول هذا البلاغ.",
        },
        terms: {
          label:
            "أقر بأن المعلومات المقدمة صحيحة وأنا على علم بالعواقب القانونية للتقارير الكاذبة.",
        },
      },
      alerts: {
        optionalData: "بيانات الاتصال اختيارية لكنها تساعد في التحقيق.",
        dataProtection: {
          title: "حماية البيانات",
          description:
            "بياناتك الشخصية محمية وفقا لقانون حماية البيانات وتستخدم فقط للتحقيق.",
        },
        falseReport: {
          title: "تنبيه",
          description:
            "قد تؤدي البلاغات الكاذبة إلى مسؤولية قانونية. تأكد من دقة المعلومات.",
        },
      },
      summary: {
        title: "ملخص البلاغ",
        type: "النوع:",
        location: "المكان:",
        date: "التاريخ:",
        contact: "التواصل:",
        description: "الوصف:",
        attachedImage: "الصورة المرفقة:",
      },
      buttons: {
        back: "رجوع",
        continue: "متابعة",
        submit: "إرسال البلاغ",
        submitting: "جار الإرسال... {{progress}}%",
      },
    },
    success: {
      title: "تم إرسال البلاغ بنجاح",
      subtitle: "تم تسجيل بلاغك وسيتم مراجعته من قبل فريقنا.",
      protocol: "الرقم المرجعي: #DEN-{{number}}",
      message:
        "ستتلقى رسالة تأكيد عبر البريد الإلكتروني بتفاصيل البلاغ ويمكنك متابعة الحالة من خلال لوحة التحكم.",
      buttons: {
        dashboard: "الوصول إلى اللوحة",
        home: "العودة للصفحة الرئيسية",
      },
      help: {
        text: "هل تحتاج للمساعدة؟",
        link: "تواصل مع الدعم",
      },
    },
  },
  tutorialPage: {
    header: {
      skipTutorial: "تخطي الدرس",
      startCapture: "بدء الالتقاط",
      skipToCamera: "الانتقال مباشرة للكاميرا",
    },
    steps: {
      step1: {
        title: "الوضعية الصحيحة",
        subtitle: "ضع الختم داخل المنطقة المحددة على شاشة الكاميرا.",
        tips: {
          title: "نصائح:",
          center: "ضع الختم في المركز",
          parallel: "أبق الجهاز موازيا للختم",
          avoid: "تجنب الزوايا المائلة التي تشوه الصورة",
        },
      },
      step2: {
        title: "إضاءة مناسبة",
        subtitle: "تأكد من وجود إضاءة جيدة لالتقاط جميع تفاصيل الختم.",
        examples: {
          good: "مثال جيد",
          bad: "مثال سيء",
          goodLabel: "إضاءة جيدة",
          badLabel: "إضاءة ضعيفة",
          correct: "صحيح",
          incorrect: "خاطئ",
        },
        tips: {
          title: "نصائح:",
          naturalLight: "استخدم أماكن مضاءة جيدا، ويفضل الضوء الطبيعي",
          avoidShadows: "تجنب الظلال فوق الختم",
          avoidReflections: "تجنب الانعكاسات المباشرة",
        },
      },
      step3: {
        title: "الوضوح والثبات",
        subtitle: "أبق الجهاز ثابتا وتأكد من وضوح الصورة قبل الالتقاط.",
        examples: {
          good: "مثال جيد",
          bad: "مثال سيء",
          sharp: "واضح",
          blurry: "ضبابي",
        },
        tips: {
          title: "نصائح:",
          steadyHands: "أبق يديك ثابتتين عند التقاط الصورة",
          waitFocus: "انتظر التركيز التلقائي قبل الالتقاط",
          fullSeal: "التقط صورة كاملة للختم مع جميع التفاصيل",
          avoidMovement: "تجنب الحركة المفاجئة أثناء الالتقاط",
        },
      },
    },
    navigation: {
      previous: "السابق",
      next: "التالي",
    },
    rotationModal: {
      title: "أدر هاتفك",
      description: "للحصول على أفضل تجربة، نوصي باستخدام الوضع الأفقي.",
      button: "مفهوم، لنبدأ!",
      autoRedirect: "إعادة التوجيه تلقائيا خلال 5 ثوان...",
    },
    welcomeModal: {
      title: "درس التحقق",
      subtitle: "تعلم كيفية التقاط صور مثالية للتحقق من الأختام",
      available: {
        title: "الدرس متاح",
        description: "هل ترغب برؤية درس قصير حول كيفية التقاط أفضل صورة؟",
      },
      bestResults: {
        title: "أفضل النتائج",
        description: "يساعدك الدرس على ضمان صور واضحة وعمليات تحقق دقيقة",
      },
      buttons: {
        skip: "تخطي الدرس",
        start: "عرض الدرس",
      },
    },
  },
  privacyPolicyPage: {
    title: "سياسة الخصوصية",
    company: "PRIMI TECNOLOGIA LTDA",
    introP1:
      "PRIMI TECNOLOGIA LTDA PRIMI، التي يقع مقرها في Estrada Rosa Scarpa، رقم 65، Votuparim، Santana de Parnaíba، São Paulo – SP، الرمز البريدي 06513-010، وامتثالا للمتطلبات القانونية والالتزام بتقديم خدمة ممتازة لعملائها المحتملين والزوار والعملاء والعملاء السابقين والموردين ومقدمي الخدمات والموردين السابقين ومقدمي الخدمات السابقين والمستخدمين والمتقدمين للوظائف والموظفين والموظفين السابقين (أصحاب البيانات)، تضع بموجب هذا سياسة الخصوصية الخاصة بها.",
    introP2:
      "من خلال هذه السياسة، تهدف PRIMI إلى الامتثال للمتطلبات القانونية للقانون الاتحادي رقم 13.709/2018 (القانون العام لحماية البيانات - LGPD)، وقانون حماية المستهلك (القانون الاتحادي رقم 8.078/1990) والإطار المدني للإنترنت (القانون الاتحادي رقم 12.965/2014)، بالإضافة إلى تحديثاتها والمعايير التكميلية، مما يضمن أنه في كل تفاعل ومعالجة لبيانات أصحاب البيانات هناك عمليات قوية وتقنية تعزز أمن البيانات والمعلومات.",
    introP3:
      "ليس فقط من خلال شهادات الأمان الخاصة بها، تمتلك PRIMI فريقا متخصصا ومدربا لحماية جميع البيانات المجمعة وتعمل بشفافية هذه السياسة لطمأنة أصحاب البيانات بأن بياناتهم محمية ضد التسريبات والانتهاكات، واستخدامها بدقة للأغراض المصرح بها.",
    introP4:
      "نحن نجمع ونستخدم بعض البيانات الشخصية لمستخدمينا، كمسيطرين ومعالجين لهذه البيانات الشخصية، مع الخضوع لجميع الأحكام التنظيمية المرتبطة.",
    introP5:
      "PRIMI هي المسؤولة عن معالجة البيانات الشخصية لأصحاب البيانات وتحدد أغراض ووسائل المعالجة من خلال هذه السياسة المتاحة على موقعنا الإلكتروني وقنواتنا ومنصاتنا.",
    introP6:
      "وبالتالي، بموجب هذه الشروط، يمنح أصحاب البيانات الموافقة الكاملة على معالجة بياناتهم الشخصية.",
    section1: {
      title: "أولا: البيانات المجمعة وطريقة الجمع",
      p1: "البيانات التي تجمعها PRIMI بموافقة أصحاب البيانات هي: بيانات التسجيل (الاسم، CPF، رقم الهاتف، وغيرها)؛ بيانات الوصول (كلمات المرور، وغيرها)؛ المعلومات الرقمية ومعلومات التصفح (الكوكيز، وغيرها)؛ البيانات المالية (بيانات الدفع، معلومات أخرى).",
      p2: "يتم جمع هذه البيانات مباشرة من أصحاب البيانات عبر المنصات نفسها أو بشكل غير مباشر عبر أطراف ثالثة.",
      p3: "فيما يتعلق بالمعلومات والبيانات المقدمة من أصحاب البيانات، يتم الجمع المباشر عبر المنصات الرقمية لـ PRIMI (الموقع الإلكتروني، منصة Primi، الختم الذكي، مراكز الخدمة، النماذج، روبوتات المحادثة، وغيرها).",
      p4: "فيما يتعلق بالمعلومات والبيانات التي يتم الحصول عليها عبر أطراف ثالثة، تتلقى PRIMI البيانات والمعلومات عبر أطراف ثالثة وسيطة، على سبيل المثال، منصات التوظيف والجهات الحكومية بما في ذلك أنظمة معلومات الائتمان، وغيرها.",
      p5: "يمكن أيضا الحصول على المعلومات والبيانات تلقائيا عبر الأجهزة التي يستخدمها أصحاب البيانات. تستخدم هذه المعلومات لتحسين تجربة أصحاب البيانات على منصاتنا وأدواتنا، مثل الكوكيز والعلامات وإشارات التحقق للتحكم في الهوية والجلسة، على سبيل المثال.",
      p6: "بالإضافة إلى ذلك، قد يتم جمع البيانات من وسائل التواصل الاجتماعي (LinkedIn، Instagram، Facebook) والجهات الحكومية (Inmetro، بوابة الشفافية، وغيرها).",
    },
    section2: {
      title: "ثانيا: المعالجة - التخزين وحماية البيانات",
      p1: "بيانات أصحاب البيانات محمية ومؤمنة بأفضل التقنيات والأساليب والعمليات الداخلية لمنع التسريبات والانتهاكات.",
      p2: "تمتلك PRIMI شهادات أمان مثل ISO 27001 – أمن المعلومات و NBR 15540 – الأمان الرسومي، وتعتمد عمليات مادية ورقمية لحماية بياناتها، بالإضافة إلى أفضل وأحدث ممارسات الأمان في تكنولوجيا المعلومات.",
      p3: "تحمي PRIMI بياناتها من خلال الوصول المقيد إلى البيانات الشخصية، بما في ذلك الوصول الإلكتروني والمادي المحمي بكلمة مرور وإخفاء البيانات وإخفاء الهوية، من بين تقنيات حماية البيانات الأخرى.",
      p4: "علاوة على ذلك، تتبنى PRIMI سياسة صارمة لأمن المعلومات، حيث تخضع عملياتها لتدقيق مستمر داخليا وخارجيا؛ وتحافظ هذه العمليات على سلامة وسرية البيانات المعالجة، خاصة لأن هذه العمليات توجه وتوجه إجراءات الموظفين الداخليين وأي أطراف ثالثة مسؤولة عن معالجة هذه البيانات.",
      p5: "فترة تخزين البيانات الشخصية هي المدة اللازمة لاستخدامها، حسب التزام التخزين القانوني المعني واحتياجات PRIMI ومصلحتها المشروعة.",
    },
    section3: {
      title: "ثالثا: الغرض من جمع البيانات",
      p1: "جميع البيانات التي تجمعها PRIMI لها أغراض متعددة، منها على سبيل المثال لا الحصر:",
      list: [
        {
          label: "لإعداد منتجاتنا:",
          text: "في صناعة المواد، قد تستخدم PRIMI البيانات الواردة من العملاء والجهات الحكومية، كونها متطلبات ضرورية للطباعة الأمنية؛",
        },
        {
          label: "للامتثال لالتزاماتنا القانونية وممارسة حقوقنا بانتظام:",
          text: "تستخدم بيانات أصحاب البيانات للوفاء بالالتزامات القانونية تجاه الجهات الحكومية والهيئات التنظيمية (ANPD، INMETRO، وغيرها). حتى بعد انتهاء العلاقة مع PRIMI، ستبقى البيانات تحت سيطرتها، نظرا لأن بعض البيانات الشخصية قد تكون ضرورية لممارسة PRIMI لحقوقها المكفولة قانونا، بما في ذلك كدليل في الإجراءات القضائية أو الإدارية أو التحكيمية؛",
        },
        {
          label: "لاستخدام منصاتنا الرقمية وخدمات دعم العملاء:",
          text: "قد تستخدم PRIMI بيانات أصحاب البيانات لتحسين وتخصيص منصاتنا وفقا لملف المستخدم الخاص بهم من خلال تقنيات محددة؛",
        },
        {
          label: "لتنفيذ أنشطة التسويق والاتصالات مع أصحاب البيانات:",
          text: "قد تستخدم PRIMI بيانات أصحاب البيانات لإعداد اتصالات وحملات تسويقية محددة. كما أن معالجة البيانات ضرورية للتفاعل مع خدماتنا؛",
        },
        {
          label: "لمنع الاحتيال وتحليل الائتمان:",
          text: "قد تستخدم PRIMI بيانات أصحاب البيانات لتحليل الملف الشخصي في نطاق أنشطتنا؛",
        },
        {
          label: "لتحقيق المصلحة المشروعة لـ PRIMI:",
          text: "قد تستخدم PRIMI بيانات أصحاب البيانات لإجراء دراسات إحصائية وإنشاء مقاييس ومؤشرات ولعمليات التوظيف وتعيين الموردين ومقدمي الخدمات والحملات التسويقية للمنتجات و/أو العروض.",
        },
      ],
    },
    section4: {
      title: "رابعا: مشاركة البيانات الشخصية",
      p1: "تشارك PRIMI البيانات الشخصية فقط مع أطراف ثالثة لتحقيق مصلحة مشروعة ومع السلطات العامة للامتثال للالتزامات القانونية ووفقا للأحكام القانونية والقضائية.",
      p2: "في هذه المشاركة للبيانات الشخصية، تمتلك PRIMI عمليات لضمان أن الطرف المتلقي يتلقى هذه البيانات بشكل مناسب، مما يضمن سرية نقل البيانات. تقوم PRIMI بنقل البيانات التي قد تكون دولية، عبر عمليات آمنة مع موردين موثوقين.",
    },
    section5: {
      title: "خامسا: حقوق وواجبات أصحاب البيانات",
      p1: "في أي وقت، يحق لأصحاب البيانات معرفة معلومات عن معالجة بياناتهم الشخصية؛ وما هي البيانات الشخصية التي تتم معالجتها؛ ولأي غرض تتم معالجتها؛ وطلب وتصحيح البيانات غير الكاملة أو غير الدقيقة أو القديمة؛ وطلب إخفاء الهوية أو الحظر أو حذف البيانات التي يرونها مفرطة؛ وطلب مراجعة البيانات التي تهمهم؛ وطلب حذف البيانات المعالجة بالموافقة، إلا للامتثال لالتزام قانوني أو مصلحة مشروعة أخرى لـ PRIMI؛ ورفض الموافقة - في هذه الحالة، ستعلم PRIMI بعواقب عدم الموافقة.",
      p2: "لأصحاب البيانات الحق في معرفة كيفية معالجة PRIMI لبياناتهم، مع رد إلزامي خلال 15 يوما بصيغة كاملة أو فورا برد مبسط.",
      p3: "قد تتضمن بيانات أصحاب البيانات المعالجة معلومات عن غرض المعالجة وفئات البيانات وفترات التخزين والكيانات التي تمت مشاركة البيانات معها. كما يمكن لأصحاب البيانات طلب نقل البيانات - باستثناء البيانات التي تم إخفاء هويتها بالفعل.",
      p4: "توصي PRIMI أصحاب البيانات بالحفاظ دائما على سرية معلومات تسجيل الدخول وكلمة المرور، وعدم مشاركة بياناتهم ومعلوماتهم الشخصية مع أطراف ثالثة أبدا. لا يمكن تحميل PRIMI المسؤولية عن المشاركة غير المناسبة لهذه البيانات من قبل أصحاب البيانات أنفسهم.",
      p5: "يجب على أصحاب البيانات دائما تقديم معلومات صحيحة عند استخدام منتجاتنا وخدماتنا، تحت طائلة العقوبات القانونية المطبقة.",
    },
    section6: {
      title: "سادسا: الاتصال بمسؤول حماية البيانات",
      p1: "لأي احتياجات اتصال، أو ممارسة حقوقك، أو توضيح استفساراتك مع PRIMI، يمكنك الاتصال مباشرة بمسؤول حماية البيانات، السيدة Victória Colombarolli Ferreira.",
      p2: "الاتصال:",
      email: "dpo@primi.com.br",
    },
    section7: {
      title: "سابعا: أحكام ختامية",
      p1: "أخيرا، تحتفظ PRIMI بالحق في تعديل هذه السياسة وإشعار الخصوصية في أي وقت، مع إبقائها محدثة ومتاحة دائما على",
      link: "https://primi.com.br/privacidade",
    },
    copyright: "© {year} Primi Tecnologia Ltda. جميع الحقوق محفوظة.",
  },
  termsOfUsagePage: {
    title: "شروط وأحكام الاستخدام",
    subtitle: "منصة Validador",
    introP1:
      "تحدد شروط وأحكام الاستخدام هذه القواعد العامة لـ PORTAL S.I.، المتاحة عبر بوابة إلكترونية على النطاق",
    introP1End: "، بين الأطراف التالية:",
    introP2:
      "Primi Tecnologia Ltda. (PRIMI)، مقرها في Estrada Rosa Scarpa، رقم 65، Votuparim، Santana de Parnaíba، ساو باولو – SP، الرمز البريدي 06513-010.",
    introP3:
      "ومن الجانب الآخر، الشخص الطبيعي أو الاعتباري المسجل في PORTAL S.I.، ويشار إليه فيما يلي باسم المستخدم. قراءة وقبول هذه الوثيقة يعني قبول شروط وأحكام الاستخدام هذه لـ PORTAL S.I.",
    introP4:
      "إذا كنت لا توافق على أي حكم من هذه الشروط، فيرجى عدم استخدام خدماتنا. لا تنطبق هذه الشروط على مواقع الإنترنت التابعة لجهات خارجية و/أو الخدمات والمنتجات المقدمة من أطراف ثالثة، حتى لو كانت مرتبطة بـ PORTAL S.I.، أو معلن عنها على PORTAL S.I.، أو تم الوصول إليها بأي شكل من الأشكال عبر PORTAL S.I.",
    introP5:
      "يحتفظ PORTAL S.I. بالحق في تغيير شروط وأحكام الاستخدام هذه في أي وقت، لتعكس بشكل مناسب الخدمات والسياسات والممارسات المحدثة.",
    section1: {
      title: "أولا: الخدمات والأحكام العامة",
      p1: "PORTAL S.I. هي منصة مجانية مخصصة للبحث عن المعلومات والإجراءات المتعلقة بأصالة ومنشأ وملاءمة المواد المطبوعة وأجهزة الأمن، وفقا للمعايير المنصوص عليها في هذه الشروط.",
      p2: "الغرض من PORTAL S.I. هو حصرا إعلام وتوجيه المواطنين بطريقة بسيطة وسهلة وشفافة حول ملاءمة أختام الأمان.",
      p3: "يصرح المستخدم ويقر بأن أي استعلام يتم إجراؤه على PORTAL S.I. سيتم مع مراعاة قواعد البيانات التي أنتجها هو نفسه حصرا، ولا يتحمل PORTAL S.I. المسؤولية عن نتائج خاطئة ناشئة عن معلومات غير كاملة، أو معلومات خاطئة، أو أخطاء إجرائية، أو أعطال في معدات المستخدم.",
      p4: "بهذا المعنى، لا يضمن PORTAL S.I.، تحت أي ظرف من الظروف، أن أي استعلام سيحدد ما إذا كان الختم الذي تم الاستعلام عنه أصليا أم مزيفا، حيث تقع على عاتق المستخدم دائما مسؤولية التحقق من المعلومات الواردة في الختم، أو طلب تحليل مادي للختم من PORTAL S.I.، أو طلب التوجيه من سلطات الرقابة.",
      p5: "يمكن إضافة أنواع جديدة من الأسئلة والأنشطة في أي وقت، مع مراعاة الحاجة والملاءمة والأهمية وتوافر هذه المعلومات.",
    },
    section2: {
      title: "ثانيا: التعريفات",
      p1: "التعريفات واردة في سياسة الخصوصية الخاصة بـ PRIMI.",
    },
    section3: {
      title: "ثالثا: الملكية الفكرية",
      p1: "جميع المحتويات والمواد والخدمات الموجودة على PORTAL S.I. (النصوص، الصور، الصوت، التكنولوجيا، الشعارات، العلامات التجارية، التعبيرات الإعلانية، النطاقات، الأسماء التجارية، الأعمال الفكرية)، بالإضافة إلى البرامج التي تمكن الأنشطة، هي ملكية حصرية لـ PRIMI، التي تمتلك جميع حقوق النشر والتراخيص وحقوق الملكية الفكرية أو العلامات التجارية أو براءات الاختراع المتعلقة بها. أي انتهاك لحقوق الملكية الفكرية من قبل المستخدم سيؤدي إلى مسؤوليته المباشرة والشخصية عن الأفعال المرتكبة، وفقا لأحكام القانون وتطبيق العقوبات المدنية والجنائية المناسبة.",
      p2: "يتعهد المستخدم بعدم إعادة إنتاج أو نسخ أو تكرار أو استغلال الخدمات المقدمة أو البرامج المستخدمة و/أو المواد المتاحة من PRIMI لأي أغراض غير مصرح بها صراحة في هذا الشرط، دون إذن كتابي منها. كما يحظر على المستخدم استخدام الهندسة العكسية.",
    },
    section4: {
      title: "رابعا: المدة والإنهاء وتعديل البنود",
      p1: "تسري هذه الشروط لمدة غير محددة أو طالما أن PORTAL S.I. متاح. ومع ذلك، يحتفظ PORTAL S.I. بالحق في أي وقت، دون أي رسوم أو إشعار مسبق، في إنهاء أنشطته أو الحد من استخدام خدماته.",
      p2: "يحتفظ PORTAL S.I. بالحق في حظر وصول المستخدم وإنهاء هذه الشروط فورا، دون إشعار مسبق، كلما رأى، وفقا لتقديره المطلق، وجود دلائل على استخدام احتيالي أو غير قانوني لـ PORTAL S.I. من قبل المستخدم. يشمل ذلك، من بين أمور أخرى، أي مؤشرات - وفقا لتقدير PORTAL S.I. المنفرد والموضوعي - على أن المستخدم قد احتال أو انتهك نظام الأمان.",
    },
    section5: {
      title: "خامسا: عدم مسؤولية PORTAL S.I.",
      p1: "يقر المستخدم ويوافق على أنه على الرغم من أن PORTAL S.I. يبذل قصارى جهده لتوفير البحث الأكثر دقة حول أختام أمان طفايات الحريق، إلا أنه لا يمكن ضمان دقة أو فعالية أو ملاءمة أي معلومات يتم تقديمها.",
      p2: "يجب على المستخدم تحمل المسؤولية الكاملة وقبول جميع المخاطر الكامنة في استخدام PORTAL S.I. يتم تقديم أي معلومات متعلقة بـ PORTAL S.I. أو متاحة عليه، بما في ذلك نتائج عمليات البحث التي تم إجراؤها، على أساس الثقة والشرط بأن المستخدم قد قدم واستوفى جميع الخطوات بأمانة، وأنها لم تنشأ لتلبية احتياجات محددة، ولا لتوجيه المستخدم بشأن الامتثال للتشريعات الحالية، أو للتأثير سلبا على عملية الشراء أو اختيار أي مورد معين، وقد تتضمن معلومات غير دقيقة فنية أو قانونية أو تنظيمية أو أخطاء مطبعية.",
      p3: "يحتفظ PORTAL S.I. بالحق في إضافة أو حذف أو تعديل وظائفه ونطاقاته، كليا أو جزئيا، في أي وقت، دون إشعار مسبق.",
      p4: "سيبذل PORTAL S.I. قصارى جهده للبقاء متاحا بشكل مستمر ومتواصل وخال من أي أخطاء؛ ومع ذلك، لن يكون PORTAL S.I. مسؤولا عن الأضرار الناشئة عن فشل أو انقطاع في تقديم الخدمات المتاحة.",
      p5: "لا يقدم PORTAL S.I. أي ضمانات من أي نوع فيما يتعلق بالاستعلامات التي يتم إجراؤها. وبهذا المعنى، يصرح المستخدم بأنه على علم ويوافق على أن PORTAL S.I. يتخلى عن أي مسؤولية عن أي ضمانات ضمنية أو غير منصوص عليها صراحة هنا، بما في ذلك، على سبيل المثال لا الحصر، أي ضمانات للملاءمة لغرض معين.",
      p6: "PORTAL S.I. غير مسؤول ولا يقدم أي ضمان لدقة أو فعالية أو توقيت أو ملاءمة أي معلومات أو محتوى أو منتج أو خدمة مقدمة من أطراف ثالثة، بما في ذلك الروابط التشعبية لصفحات أطراف ثالثة.",
      p7: "لا يضمن PORTAL S.I. أنه سيكون خاليا من الأخطاء و/أو أنه سيكون متاحا 24 (أربعا وعشرين) ساعة يوميا طوال 7 (سبعة) أيام في الأسبوع. يحتفظ PORTAL S.I. بالحق في أن يصبح غير متاح للفترة اللازمة للصيانة و/أو تنفيذ التحسينات.",
      p8: "لن يكون PORTAL S.I.، تحت أي ظرف من الظروف، مسؤولا عن الأضرار غير المباشرة أو الأرباح الفائتة أو فقدان البيانات المتعلقة باستخدامه.",
    },
    section6: {
      title: "سادسا: أحكام عامة",
      p1: "باستخدام PORTAL S.I.، يوافق المستخدم صراحة على جميع بنود هذه الوثيقة، وكذلك على الأنشطة القائمة والمستقبلية، معترفا بها على أنها بريئة وصحية وحسنة النية وغير مسيئة، وقابلا لقواعدها وتعليماتها وشروطها الواردة في الموقع نفسه، بشكل مطلق وغير مقيد، ضامنا أنه لن يشعر بأي شكل من الأشكال بالإهانة أو الإساءة أو الضرر بسببها.",
      p2: "إذا أنشأ PORTAL S.I. نشاطا لا يعتبره المستخدم بأي شكل من الأشكال بريئا أو صحيا أو حسن النية أو غير مسيء، أو قد يسيء إليه أو يضره في النهاية، فيلتزم المستخدم بوقف استخدام الخدمات.",
      p3: "أي دعوى قضائية أو خارج القضاء قد ترفع ضد PORTAL S.I. بسبب خرق أو انتهاك أي بند أو حكم من هذه الوثيقة، ستلزم المستخدم بالتعويض الكامل، وإذا كان الأمر كذلك، بالرجوع، عن جميع الخسائر والأضرار التي لحقت بـ PORTAL S.I. و/أو أطراف ثالثة.",
      p4: "الخدمات والمحتويات المتاحة على مواقع الأطراف الثالثة هي المسؤولية الوحيدة والحصرية للطرف الثالث. أنت تقر وتوافق على أن PORTAL S.I. لا يضمن ولا يؤيد ولا يتحمل أي مسؤولية فيما يتعلق بمنتجات أو خدمات أو مواقع أطراف ثالثة.",
      p5: "يوفر PORTAL S.I. للمستخدم قناة لتوضيح الاستفسارات والاقتراحات والشكاوى المتعلقة بالخدمات المقدمة، عبر قنوات الاتصال المتاحة في سياسة الخصوصية الخاصة بـ PRIMI.",
    },
    section7: {
      title: "سابعا: الخصوصية والأمان وملفات تعريف الارتباط ومعالجة البيانات",
      p1: "جميع البنود المتعلقة بالخصوصية والأمان وملفات تعريف الارتباط ومعالجة البيانات تمت معالجتها في سياسة الخصوصية الخاصة بـ PRIMI.",
    },
    section8: {
      title: "ثامنا: القانون الواجب التطبيق والاختصاص القضائي",
      p1: "تخضع هذه الشروط حصرا وبشكل كامل لقوانين جمهورية البرازيل الاتحادية، وأي نزاع قانوني ينشأ عن تفسيرها أو تطبيقها سينظر فيه أمام المحاكم البرازيلية، مع اختيار محكمة عاصمة ولاية ساو باولو، مهما كانت محكمة أخرى أكثر امتيازا أو قد تصبح كذلك.",
    },
    copyright: "© {year} Primi Tecnologia Ltda. جميع الحقوق محفوظة.",
  },
  cookieConsentBanner: {
    description:
      "نستخدم ملفات تعريف الارتباط لمساعدتك في التنقل عبر موقعنا وتحسين خدماتنا. بمواصلة التصفح، فأنت توافق على شروط الاستخدام و",
    privacyLink: "سياسة الخصوصية.",
    descriptionSuffix: "",
    acceptAll: "قبول جميع ملفات تعريف الارتباط",
    rejectNonEssential: "رفض ملفات تعريف الارتباط غير الضرورية",
  },
};
